export default (files, selection) => (
  Object.keys(selection).reduce((filteredFiles, key) => {
    const sgKey = key.substring(0, key.length - 1);

    return filteredFiles.filter(file => file[sgKey] === selection[key])
  }, files)
)